<template>
  <router-view />
  <!-- <WelcomeModal 
    v-if="showModal" 
    @accept="handleAccept" 
    @reject="handleReject" 
  /> -->
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import WelcomeModal from './components/en/WelcomeModal.vue'
  import { initGlobalLanguage } from '@/components/utils/language.js';
  
  const showModal = ref(false)
  const router = useRouter()
  const route = useRoute()
  
  // 检查是否需要显示弹窗
  const checkShouldShowModal = () => {
    // 1. 检查 localStorage 中是否有今天的记录
    const storedDate = localStorage.getItem('welcomeAcceptedDate')
    
    if (storedDate) {
      const today = new Date().toDateString()
      const storedDay = new Date(storedDate).toDateString()
      
      // 如果是今天已经接受过，则不显示
      if (today === storedDay) {
        return false
      }
    }
    
    // 2. 检查访问方式
    const referrer = document.referrer
    const currentOrigin = window.location.origin
    
    // 判断是否为外部跳转
    const isExternalReferrer = referrer && !referrer.includes(currentOrigin)
    const isDirectAccess = !referrer
    
    // 无论什么访问方式都显示弹窗（只要今天没接受过）
    // 关键：只要今天没接受过，就显示弹窗
    const shouldShow = true
    return shouldShow
  }
  
  // 处理 Accept 按钮点击
  const handleAccept = () => {
    // 存储当前日期到 localStorage
    const today = new Date()
    localStorage.setItem('welcomeAcceptedDate', today.toISOString())
    showModal.value = false
    
    // 添加一个标记表示用户已经接受
    localStorage.setItem('welcomeAccepted', 'true')
  }
  
  // 处理 Do Not Accept 按钮点击
  const handleReject = async () => {
    try {
      // 尝试后退
      if (window.history.length > 1) {
        // 如果有历史记录，则后退
        router.go(-1)
      } else {
        // 如果没有历史记录，尝试关闭窗口（需要用户授权）
        if (window.opener) {
          window.close()
        } else {
          window.location.href = 'about:blank'
        }
      }
    } catch (error) {
      // 如果后退失败，尝试关闭或重定向
      window.location.href = 'about:blank'
    }
  }
  
  // 监听路由变化
  watch(() => route.path, () => {
    // 每次路由变化时检查是否需要显示弹窗
    const shouldShow = checkShouldShowModal()
    if (shouldShow) {
      showModal.value = true
    }
  })
  
  onMounted(() => {
    initGlobalLanguage();
    // 页面加载时检查是否需要显示弹窗
    const shouldShow = checkShouldShowModal()
    
    if (shouldShow) {
      // 使用 setTimeout 确保在页面加载完成后再显示弹窗
      setTimeout(() => {
        showModal.value = true
      }, 500) // 延迟 500ms 显示，让页面先加载完成
    }
  })
  </script>

<style scoped>

</style>